import { ISapAssetDetail } from "@/types/sapAsset.type"

export interface IAssetEditDraft {
  recordId: string
  assets: ISapAssetDetail[]
  savedAt: string
  baseUpdatedAt: string | null
}

const DRAFT_STORAGE_PREFIX = "sapasst-edit-draft:"

const getDraftKey = (recordId: string): string => `${DRAFT_STORAGE_PREFIX}${recordId}`

export const getAssetEditDraft = (recordId: string): IAssetEditDraft | null => {
  try {
    const rawDraft = window.localStorage.getItem(getDraftKey(recordId))
    if (!rawDraft) return null

    const parsedDraft = JSON.parse(rawDraft) as IAssetEditDraft
    if (!parsedDraft || parsedDraft.recordId !== recordId || !Array.isArray(parsedDraft.assets)) {
      window.localStorage.removeItem(getDraftKey(recordId))
      return null
    }

    return parsedDraft
  } catch (_error) {
    window.localStorage.removeItem(getDraftKey(recordId))
    return null
  }
}

export const saveAssetEditDraft = (draft: IAssetEditDraft): void => {
  window.localStorage.setItem(getDraftKey(draft.recordId), JSON.stringify(draft))
}

export const removeAssetEditDraft = (recordId: string): void => {
  window.localStorage.removeItem(getDraftKey(recordId))
}
